module.exports = "../static/media/logo.70100d29.png";